import { renderPDFReport, type ReportData } from './renderer/render-pdf-report';

export const generatePDFReport = renderPDFReport;

export async function generatePDFReportURL(reportData: ReportData, signal?: AbortSignal) {
  const pdf = await renderPDFReport(reportData);
  if (signal?.aborted) return null;
  const blob = await pdf.toBlob();
  if (signal?.aborted) return null;
  const url = URL.createObjectURL(blob);
  return url;
}

export type EnhancedIframe = HTMLIFrameElement & { pdfUrl?: string };

export async function renderPDFReportToIframe(
  reportData: ReportData,
  iframe?: Maybe<EnhancedIframe>,
) {
  if (!iframe) return;

  if (iframe.pdfUrl) {
    URL.revokeObjectURL(iframe.pdfUrl);
    iframe.pdfUrl = undefined;
  }

  const pdfUrl = await generatePDFReportURL(reportData);
  if (!pdfUrl) return;
  iframe.src = pdfUrl;
}

export async function downloadPDFReport(reportData: ReportData, signal?: AbortSignal) {
  const pdfUrl = await generatePDFReportURL(reportData, signal);
  if (!pdfUrl) return;
  const a = document.createElement('a');
  a.href = pdfUrl;
  a.download = sanitizeTitleForFilename(reportData.title ?? 'teo-report') + '.pdf';
  if (!signal?.aborted) {
    a.click();
  }
}

function sanitizeTitleForFilename(title: string) {
  return title.replace(/[^a-zA-Z0-9-\\. ]/g, '_');
}
